import GlobalQuickJump from "../../../../../global/GlobalQuickJump";

export default function OfficeToAndFroQuickJumpSection(props) {
  return <GlobalQuickJump {...props} />;
}
